<template>
  <TepmplateBlock
    content-class="chat-wrap mt-4"
    mod-class
    title-page="Список офисов"
  >
    <div class="scroll-container">
      <vuescroll>
        <div v-if="employees.length" class="pt-0 pb-0 pr-4 pl-4">
          <office-list-item
            v-for="(office, index) in sortedOffices"
            :key="index"
            :office="office"
            :employees="employees"
          />
        </div>
      </vuescroll>
    </div>
  </TepmplateBlock>
</template>

<script>
import TepmplateBlock from "../../components/TepmplateBlock";
import vuescroll from "vuescroll";
import OfficeListItem from "../../components/OfficeListItem";
import RequestManager from "../../function/request/RequestManager";

export default {
  name: "OfficesList",
  components: { TepmplateBlock, vuescroll, OfficeListItem },
  data() {
    return {
      employees: []
    };
  },
  computed: {
    sortedOffices() {
      const allOffices = this.$store.getters.officeList
        ? this.$store.getters.officeList
        : [];
      return allOffices.sort((a, b) =>
        a.office_name.localeCompare(b.office_name)
      );
    }
  },
  methods: {
    fetchData() {
      RequestManager()
        .getUsersList()
        .then(data => {
          this.employees = data.results.map(user => {
            return {
              text: user.first_name + " " + user.last_name,
              link: "/edit-user/" + user.id + "/",
              src: user.profile_picture
                ? user.profile_picture
                : "https://placehold.it/51x51",
              userRole: user.role,
              id: user.id,
              userId: user.id
            };
          });
        });
    }
  },
  created() {
    this.fetchData();
  }
};
</script>

<style scoped>
.scroll-container {
  width: 100% !important;
  margin: 0 auto;
  overflow: hidden;
}
</style>
